import React from "react";
import TableNumberBase8 from "../TableNumberBase8";
import "./TableNumberBaseNull3.css";

function TableNumberBaseNull3(props) {
  const { tableNumberBase8Props } = props;

  return (
    <div className="table-number-base-null-4">
      <TableNumberBase8 keyProps={tableNumberBase8Props.keyProps} />
    </div>
  );
}

export default TableNumberBaseNull3;
